jQuery(document).ready(function() {

// Custom JS functions

//reviews slider
if($('.reviews-slick')[0]) {
    $('.reviews-slick').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:false,
      nextArrow: '<i class="fas fa-arrow-right"></i>',
      prevArrow: '<i class="fas fa-arrow-left"></i>',
      adaptiveHeight:true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            autoplay:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplaySpeed: 5000,
          },
        } ],
    });
}
if($('.card-slider')[0]) {
	$('.card-slider').slick({
		dots: false,
		infinite: true,
		nextArrow: '<i class="fas fa-chevron-right"></i>',
		prevArrow: '<i class="fas fa-chevron-left"></i>',
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
				},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
				}],
	});
}
$(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox();
});

/** hero slider **/
$('.hero-bkg-slider, .absolute-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    pauseOnHover:false,
    pauseOnFocus:false,
    autoplaySpeed: 8000,
});

/** navigation hover functions **/
function toggleDropdown (e) {
  var d = $(this);
  var m = $($(this).find('.dropdown-menu')[0]);
  console.log($(this));
  setTimeout(function(){
    var shouldOpen = e.type !== 'click' && d.is(':hover');
    m.toggleClass('show', shouldOpen);
    d.toggleClass('show', shouldOpen);
    $('[data-toggle="dropdown"]', d).attr('aria-expanded', shouldOpen);
  }, e.type === 'mouseleave' ? 50 : 0);
}

$(window).on('load resize', function() {
    $('body').on('mouseenter mouseleave','.dropdown',toggleDropdown);
});

// Nav Style 6 functions
$('#desktopToggler').click(function() {
  $('.off-canvas-transform-menu').addClass('nav-flex');
  $('#siteVisibleArea').removeClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').addClass('site-visible-area');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner');
  $('#canvasX').delay(500).fadeIn();
  $('#offCanvasMenu').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
});

var mobileClicked = 0;

$('#mobileToggler').click(function() {
  if( mobileClicked == 0) {
    $('#siteVisibleArea').removeClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').addClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-mobile');
    $('#offCanvasMobile').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
    mobileClicked = 1;
  }
  else if(mobileClicked == 1) {
    $('#siteVisibleArea').addClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').removeClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-mobile');
    $('#offCanvasMenu').hide();
    mobileClicked = 0;
  }
});

$('#canvasX').click(function() {
  $('.off-canvas-transform-menu').removeClass('nav-flex');
  $('#siteVisibleArea').addClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').removeClass('site-visible-area');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner');
  $('#canvasX').hide();
  $('#offCanvasMenu').hide();
});

//modal functions for team bios
$('.open-bio').click(function() {
   $('.header-style-3-nav').css({'z-index':'2'});
   var bio_id = $(this).attr('bio_target');
   if($(this).hasClass('bio_999')) {
     $('#bio_999').addClass('d-block');
   } else {
     $('#'+bio_id).addClass('d-block');
   }
});
$('.modal-header button.close').click(function() {
    $('.modal').removeClass('d-block');
    $('.modal').addClass('d-none');
    $('.header-style-3-nav').css({'z-index':'10001'});
});

//scroll to id
  $('a[href*="#"]').click(function(e){
      e.preventDefault();

      $('html, body').animate({
         scrollTop: $($(this).attr('href')).offset().top - 77,
      }, 500, 'linear');

      if($(this).parents('.show').length) {
          $('.navbar-collapse').removeClass('show');
      }
  });
//end jQuery
});



// WEBPACK FOOTER //
// ./scripts/mta.js